import React, { createContext, lazy, useEffect, useState, Suspense, startTransition, useRef } from "react";
import { createPortal } from "react-dom";
import translations from "../../translations";
import { endPointsJobMailer } from "../../utils/Endpoints";
const Loading = lazy(() => import("../Loading"));
const Dialog = lazy(() => import("./Dialog"));
export const ConfigContext = createContext(null);
function TmsDialogOverlay() {
    const configName = "myTalentionConfig";
    const configObject = window[configName] || {};
    const [translation, setTranslation] = useState(translations[configObject.lang] ? translations[configObject.lang] : translations["de"]);
    const [isLoading, setIsLoading] = useState(true);
    const [showOverlay, setShowOverlay] = useState(false);
    const [hasError, setHasError] = useState(false);
    const [hasSuccess, setHasSuccess] = useState(false);
    const [errorObject, setErrorObject] = useState([]);
    const [email, setEmail] = useState("");
    const [jobadID, setJobadID] = useState(undefined);
    const submitButtonRef = useRef(null);
    const dialogRef = useRef(null);
    const getJobadID = () => {
        let url;
        let id;
        url = `${window.location.protocol}//${window.location.hostname}${window.location.pathname}`;
        if (window.location.hostname === "localhost") {
            url = window.location.href;
        }
        if (url.split("/stellenangebote/")[1] !== undefined) {
            id = parseInt(url.split("/stellenangebote/")[1].split(/[--]+/)
                .pop());
        }
        return id;
    };
    const postRequest = async (url, filter) => {
        return await fetch(url, {
            body: filter,
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, same-origin, *omit
            headers: {
                "content-type": "application/x-www-form-urlencoded",
            },
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "cors", // no-cors, cors, *same-origin
            redirect: "follow", // *manual, follow, error
            referrer: "no-referrer", // *client, no-referrer
        })
            .then((res) => {
            let text = res.text(); // there's always a body
            if (res.status >= 200 && res.status < 300) {
                return text;
            }
            return text.then(Promise.reject.bind(Promise));
        })
            .catch((err) => {
            console.log("Error: ", err);
            return Promise.reject();
        });
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        submitButtonRef.current.disabled = true;
        let payload = "";
        payload = `lang=${configObject.lang}&email=${encodeURIComponent(email)}&job.id=${jobadID}`;
        postRequest(`${configObject.clientURL}${endPointsJobMailer.send}`, payload)
            .then(function (response) {
            if (response.indexOf('errors') !== -1) {
                let div = document.createElement('div');
                div.innerHTML = response;
                const errorMessages = [];
                div.querySelectorAll('.errors ul li').forEach(element => {
                    errorMessages.push({
                        name: "COULD_NOT_SEND",
                        message: element.innerHTML,
                        type: "error"
                    });
                });
                setErrorObject(errorMessages);
                setHasError(true);
                return true;
            }
            if (response.indexOf('Die E-Mail-Nachricht wurde erfolgreich versendet') !== -1 || response.indexOf('Your message was sent') !== -1) {
                if (errorObject.length) {
                    setErrorObject([]);
                }
                setHasSuccess(true);
            }
            return true;
        });
        return true;
    };
    const resetDialog = () => {
        setHasSuccess(false);
        setEmail("");
        setShowOverlay(false);
    };
    const handleKeys = (event) => {
        if (event.key === "Escape") {
            resetDialog();
        }
    };
    const handleClick = (event) => {
        if (dialogRef.current && !dialogRef.current.contains(event.target)) {
            resetDialog();
        }
    };
    useEffect(() => {
        setJobadID(getJobadID());
    }, []);
    useEffect(() => {
        if (jobadID) {
            setIsLoading(false);
        }
    }, [jobadID]);
    useEffect(() => {
        if (showOverlay) {
            document.addEventListener("keydown", handleKeys, false);
            document.addEventListener('mousedown', handleClick, false);
        }
        else {
            document.removeEventListener("keydown", handleKeys, false);
            document.removeEventListener('mousedown', handleClick, false);
        }
    }, [showOverlay]);
    useEffect(() => {
        if (errorObject.length) {
            setTimeout(() => {
                if (submitButtonRef.current !== null) {
                    submitButtonRef.current.disabled = false;
                }
            }, 2000);
        }
    }, [errorObject]);
    if (isLoading) {
        return null;
    }
    const dialog = showOverlay ? createPortal(React.createElement(Suspense, { fallback: React.createElement(Loading, null) },
        React.createElement(Dialog, { email: email, setEmail: setEmail, showOverlay: showOverlay, setShowOverlay: setShowOverlay, submitButtonRef: submitButtonRef, dialogRef: dialogRef })), document.body) : null;
    return (React.createElement(ConfigContext.Provider, { value: {
            translation,
            handleSubmit: handleSubmit,
            hasError: hasError,
            hasSuccess: hasSuccess,
            errorObject: errorObject,
        } },
        React.createElement("div", { id: "tms-dialog-overlay-wrap", className: "tms-dialog-overlay-wrap" },
            React.createElement("div", { className: "tms-dialog-overlay-print" },
                React.createElement("a", { className: "tms-dialog-overlay-send-button tms-dialog-overlay-send-button--print", onClick: () => window.print() }, translation.print)),
            React.createElement("div", { className: "tms-dialog-overlay-separator" }),
            React.createElement("div", { className: "tms-dialog-overlay-send" },
                React.createElement("a", { className: "tms-dialog-overlay-send-button tms-dialog-overlay-send-button--send", onClick: () => {
                        startTransition(() => {
                            setShowOverlay(true);
                        });
                    } }, translation.send))),
        dialog));
}
export default TmsDialogOverlay;
